package one.healthium.uscreen.data

import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import kotlinx.serialization.json.Json
import one.healthium.base.coroutines.IO
import one.healthium.locale.LocaleProvider
import one.healthium.uscreen.domain.UScreenRepository
import one.healthium.uscreen.domain.models.UScreenFlowModel
import one.primehealth.app.BaseAppResourceProvider

internal class AppUScreenRepository(
    private val json: Json,
    private val appResourceProvider: BaseAppResourceProvider,
    private val localeProvider: LocaleProvider,
) : UScreenRepository {
    override suspend fun get(): UScreenFlowModel {
        return withContext(Dispatchers.IO) {
            val bytes = appResourceProvider.readBytes(
                "files/onboarding/${localeProvider.getLocale()}/onboarding_uscreen_v1.json",
            )
            json.decodeFromString<UScreenFlowModel>(bytes.decodeToString())
        }
    }
}
